import type { PendingApproval } from '../../shared/types'
import { Avatar, Pill } from './ui'

/**
 * Kid ticks waiting for a parent. A job only counts toward Ready for Tomorrow
 * and points once approved, so this sits at the top of a parent's home.
 * Sending one back unticks it, so the kid can do it properly and tick it again.
 */
export function ApprovalsCard({
  pending,
  busy,
  onApprove,
  onSendBack,
}: {
  pending: PendingApproval[]
  busy: boolean
  onApprove: (item: PendingApproval) => void
  onSendBack: (item: PendingApproval) => void
}) {
  if (pending.length === 0) return null

  return (
    <section className="card">
      <div className="row-between">
        <h2 className="title">Waiting for you</h2>
        <Pill tone="warn">{pending.length}</Pill>
      </div>
      <p className="subtitle">Jobs only count once a parent says they’re done.</p>
      <div className="list">
        {pending.map((item) => (
          <div key={item.completionId} className="stack" style={{ gap: 'var(--space-2)' }}>
            <div className="row">
              <Avatar emoji={item.member.emoji} color={item.member.color} size="sm" />
              <span className="grow">
                <span className="check-title">{item.title}</span>
                <span className="check-detail" style={{ display: 'block' }}>
                  {item.member.name} · {describe(item)} · {item.points} pts
                </span>
              </span>
            </div>
            <div className="row">
              <button
                type="button"
                className="btn btn-primary grow"
                disabled={busy}
                aria-label={`Approve ${item.member.name}’s ${item.title}`}
                onClick={() => onApprove(item)}
              >
                Approve
              </button>
              <button
                type="button"
                className="btn btn-ghost grow"
                disabled={busy}
                aria-label={`Send back ${item.member.name}’s ${item.title}`}
                onClick={() => onSendBack(item)}
              >
                Send back
              </button>
            </div>
          </div>
        ))}
      </div>
    </section>
  )
}

function describe(item: PendingApproval): string {
  if (item.category === 'reward') return 'extra job'
  if (item.category === 'household') return item.cadence === 'weekly' ? 'weekly household job' : 'household job'
  return item.cadence === 'weekly' ? 'weekly job' : 'daily chore'
}
